import { useTranslations } from 'next-intl';

type GalleryMatterportProps = {
  url: string;
  className?: string;
};

export function GalleryMatterport({ url, className }: GalleryMatterportProps) {
  const t = useTranslations('location.gallery');

  return (
    <iframe
      src={url}
      className={className}
      allow="vr"
      id="iframe-virtual-tour"
      aria-label={t('matterport-alt')}
      allowFullScreen
    ></iframe>
  );
}
